var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('img',{attrs:{"src":_vm.qrcodeDataURL,"alt":"二维码","width":"90","height":"90"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }